import { CHANGE_NETWORK_STATUS } from '../actionCreators/networkActions';

const initialState = {
  isOnline: window.navigator.onLine
};

function networkReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_NETWORK_STATUS:
      return {
        ...state,
        isOnline: action.isOnline
      };
    default:
      return state;
  }
}

export default networkReducer;
